/* ===== TRKVLT Theme JS ===== */

let cartDrawerOpen = false;
let searchOpen = false;
let searchDebounce;
let addonCartPending = {};

async function fetchCart() {
  const r = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Content-Type': 'application/json' } });
  return r.json();
}

async function syncAddonToCart(addonKey, variantId, isChecked) {
  if (!variantId) return;
  if (addonCartPending[addonKey]) return;
  addonCartPending[addonKey] = true;

  try {
    if (isChecked) {
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
    } else {
      const cart = await fetchCart();
      const line = cart.items.find(i => i.variant_id == variantId);
      if (line) {
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        });
      }
    }
  } catch (err) {
    console.error('Addon cart sync failed:', err);
  } finally {
    const cart = await fetchCart();
    updateCartBadge(cart.item_count);
    if (cartDrawerOpen) { renderCartDrawer(cart); } else { refreshCartPaymentButton(); }
    addonCartPending[addonKey] = false;
  }
}

async function addToCart(variantId, qty = 1) {
  if (window.trkvltSocialProofViewed) {
    if (typeof fbq === 'function') fbq('trackCustom', 'AddToCartAfterSocialProof');
    if (typeof ttq !== 'undefined' && ttq.track) ttq.track('AddToCartAfterSocialProof');
  }
  var rpClickedAt = Number(sessionStorage.getItem('trkvltRPClickedAt') || 0);
  if (rpClickedAt && (Date.now() - rpClickedAt) < 30 * 60 * 1000) {
    if (typeof fbq === 'function') fbq('trackCustom', 'AddToCartAfterRecentPurchaseNotif');
    if (typeof ttq !== 'undefined' && ttq.track) ttq.track('AddToCartAfterRecentPurchaseNotif');
  }
  const items = [{ id: Number(variantId), quantity: qty }];

  const btn   = document.getElementById('pd-atc-btn');
  const spBtn = document.getElementById('pd-sp-add-btn');
  if (btn)   { btn.disabled = true;   btn.textContent = 'Adding…'; }
  if (spBtn) { spBtn.disabled = true; spBtn.textContent = 'Adding…'; }

  // See buyNow() for why: wait for any in-flight add-on syncs so a quick
  // click right after checking a box doesn't leave it out of the cart.
  if (window._pendingAddonSyncs && window._pendingAddonSyncs.length) {
    await Promise.all(window._pendingAddonSyncs.map(p => p.catch(() => {})));
  }

  const resp = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  });

  if (!resp.ok && items.length > 1) {
    for (const item of items) {
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
    }
  }

  if (btn)   { btn.disabled = false;   btn.textContent = btn.dataset.label || 'Add To Cart'; }
  if (spBtn) { spBtn.disabled = false; spBtn.textContent = 'Add To Cart'; }

  const cart = await fetchCart();
  updateCartBadge(cart.item_count);

  const shown = await tryShowUpsellModal();
  if (!shown) {
    renderCartDrawer(cart);
    openCartDrawer();
  }
}

async function tryShowUpsellModal() {
  const productId = window.CURRENT_PRODUCT_ID;
  if (!productId) return false;
  try {
    const resp = await fetch(window.Shopify.routes.root + 'recommendations/products?product_id=' + productId + '&section_id=product-upsell');
    if (!resp.ok) return false;
    const html = await resp.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const item = doc.querySelector('.pd-upsell-item');
    if (!item) return false;
    const content = document.getElementById('pd-upsell-content');
    if (!content) return false;
    content.innerHTML = '';
    content.appendChild(item);
    document.getElementById('pd-upsell-overlay').classList.add('show');
    document.getElementById('pd-upsell-modal').classList.add('show');
    document.body.style.overflow = 'hidden';
    return true;
  } catch (err) {
    console.error('Upsell modal failed:', err);
    return false;
  }
}

function closeUpsellModal() {
  document.getElementById('pd-upsell-overlay').classList.remove('show');
  document.getElementById('pd-upsell-modal').classList.remove('show');
  document.body.style.overflow = '';
  openCartDrawer();
}

async function addUpsellToOrder() {
  const item = document.querySelector('.pd-upsell-item');
  const btn = document.getElementById('pd-upsell-add-btn');
  if (!item) return;
  const variantId = item.dataset.variantId;
  if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
  try {
    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    });
  } catch (err) {
    console.error('Add upsell to order failed:', err);
  } finally {
    document.getElementById('pd-upsell-overlay').classList.remove('show');
    document.getElementById('pd-upsell-modal').classList.remove('show');
    document.body.style.overflow = '';
    if (btn) { btn.disabled = false; btn.textContent = 'Add To Order'; }
    const cart = await fetchCart();
    updateCartBadge(cart.item_count);
    openCartDrawer();
  }
}

let upsellAudio = null;

function toggleUpsellAudio(btn) {
  const url = btn.dataset.audio;
  if (!url) return;
  const item = btn.closest('.pd-upsell-item');
  if (!item) return;

  if (!upsellAudio) {
    upsellAudio = new Audio();
    upsellAudio.addEventListener('play', () => {
      window.dispatchEvent(new CustomEvent('trkvlt:audioplay', { detail: { source: 'upsell' } }));
    });
    upsellAudio.addEventListener('timeupdate', () => {
      const activeItem = document.querySelector('.pd-upsell-item');
      if (!activeItem || !upsellAudio.duration) return;
      const pct = (upsellAudio.currentTime / upsellAudio.duration) * 100;
      activeItem.querySelectorAll('.pd-upsell-bar').forEach((b, i, a) => {
        b.classList.toggle('played', ((i + 1) / a.length) * 100 <= pct);
      });
    });
    upsellAudio.addEventListener('ended', () => {
      const activeItem = document.querySelector('.pd-upsell-item');
      if (activeItem) {
        const b = activeItem.querySelector('.pd-upsell-play-btn');
        if (b) b.innerHTML = '<svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
        activeItem.querySelectorAll('.pd-upsell-bar').forEach(b => b.classList.remove('played'));
      }
    });
  }

  if (!upsellAudio.paused && upsellAudio.src === url) {
    upsellAudio.pause();
    btn.innerHTML = '<svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
  } else {
    upsellAudio.src = url;
    upsellAudio.play();
    btn.innerHTML = '<svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';
  }
}

async function buyNow(variantId, qty = 1) {
  const items = [{ id: Number(variantId), quantity: qty }];

  const btn = document.getElementById('pd-fastcheckout-btn');
  if (btn) { btn.disabled = true; btn.dataset.label = btn.innerHTML; btn.textContent = 'Redirecting…'; }

  try {
    // Checking an add-on checkbox kicks off syncAddonToCart() in the background.
    // If Fast Checkout is clicked before that finishes, the redirect can fire
    // before the add-on ever reaches the cart. Wait for any in-flight syncs
    // (tracked in window._pendingAddonSyncs by toggleAddon()) before continuing.
    if (window._pendingAddonSyncs && window._pendingAddonSyncs.length) {
      await Promise.all(window._pendingAddonSyncs.map(p => p.catch(() => {})));
    }

    const resp = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!resp.ok && items.length > 1) {
      for (const item of items) {
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
      }
    }
  } finally {
    window.location.href = window.Shopify.routes.root + 'checkout';
  }
}

async function changeCartItemQty(line, qty) {
  await fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: qty })
  });
  const cart = await fetchCart();
  renderCartDrawer(cart);
  updateCartBadge(cart.item_count);
}

async function removeCartItem(line) {
  await changeCartItemQty(line, 0);
}

async function clearCart() {
  await fetch(window.Shopify.routes.root + 'cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  });
  const cart = await fetchCart();
  renderCartDrawer(cart);
  updateCartBadge(cart.item_count);
}

function updateCartBadge(count) {
  const badge = document.getElementById('cart-badge');
  if (!badge) return;
  if (count > 0) {
    badge.style.display = 'inline-flex';
    badge.textContent = count;
  } else {
    badge.style.display = 'none';
  }
}

async function refreshCartPaymentButton() {
  const container = document.getElementById('cart-native-checkout-container');
  if (!container) return;
  try {
    const resp = await fetch(window.Shopify.routes.root + '?section_id=cart-native-checkout');
    if (!resp.ok) return;
    const html = await resp.text();
    container.innerHTML = html;
  } catch (err) {
    console.error('Native checkout button refresh failed:', err);
  }
}

async function renderCartRecommendations(cart) {
  const section = document.getElementById('cart-reco');
  const container = document.getElementById('cart-reco-items');
  if (!section || !container) return;

  if (!cart.items || cart.items.length === 0) {
    section.classList.remove('show');
    return;
  }

  const cartProductIds = new Set(cart.items.map(i => i.product_id));
  const seedItem = [...cart.items].reverse().find(i => {
    const t = (i.product_title || '').toLowerCase();
    return !t.includes('stem') && !t.includes('unlimited');
  }) || cart.items[0];

  try {
    const resp = await fetch(window.Shopify.routes.root + 'recommendations/products?product_id=' + seedItem.product_id + '&section_id=cart-recommendations&limit=6');
    if (!resp.ok) { section.classList.remove('show'); return; }
    const html = await resp.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const items = Array.from(doc.querySelectorAll('.cart-reco-item'));
    const filtered = items.filter(el => {
      const pid = Number(el.dataset.productId);
      if (cartProductIds.has(pid)) return false;
      const title = (el.querySelector('.cart-reco-title')?.textContent || '').toLowerCase();
      if (title.includes('stem') || title.includes('unlimited')) return false;
      return true;
    }).slice(0, 2);

    if (filtered.length === 0) { section.classList.remove('show'); return; }

    container.innerHTML = '';
    filtered.forEach(el => container.appendChild(el));
    section.classList.add('show');
  } catch (err) {
    console.error('Cart recommendations failed:', err);
    section.classList.remove('show');
  }
}

let cartRecoAudio = null;
let cartRecoActiveBody = null;

function cartRecoResetIcon(body) {
  const btn = body.querySelector('.cart-reco-play-btn');
  if (btn) btn.innerHTML = '<svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
  body.querySelectorAll('.cart-reco-bar').forEach(b => b.classList.remove('played'));
}

function toggleCartRecoAudio(btn) {
  const url = btn.dataset.audio;
  if (!url) return;
  const body = btn.closest('.cart-reco-body');

  if (!cartRecoAudio) {
    cartRecoAudio = new Audio();
    cartRecoAudio.addEventListener('play', () => {
      window.dispatchEvent(new CustomEvent('trkvlt:audioplay', { detail: { source: 'cartReco' } }));
    });
    cartRecoAudio.addEventListener('timeupdate', () => {
      if (!cartRecoActiveBody || !cartRecoAudio.duration) return;
      const pct = (cartRecoAudio.currentTime / cartRecoAudio.duration) * 100;
      cartRecoActiveBody.querySelectorAll('.cart-reco-bar').forEach((b, i, a) => {
        b.classList.toggle('played', ((i + 1) / a.length) * 100 <= pct);
      });
    });
    cartRecoAudio.addEventListener('ended', () => {
      if (cartRecoActiveBody) cartRecoResetIcon(cartRecoActiveBody);
    });
  }

  const isSameBody = cartRecoActiveBody === body;
  const wasPlaying = isSameBody && !cartRecoAudio.paused;

  if (cartRecoActiveBody && cartRecoActiveBody !== body) {
    cartRecoResetIcon(cartRecoActiveBody);
  }

  if (wasPlaying) {
    cartRecoAudio.pause();
    btn.innerHTML = '<svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
  } else {
    if (!isSameBody) {
      cartRecoAudio.src = url;
    }
    cartRecoActiveBody = body;
    cartRecoAudio.play();
    btn.innerHTML = '<svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';
  }
}

/* Site-wide audio coordination: only one audio source should ever play at
   once. Every audio owner (this file's cart-reco / upsell previews, and the
   global persistent player in global-player.js) dispatches a shared
   'trkvlt:audioplay' event whenever its own <audio> element starts playing.
   Whichever owner is NOT the source pauses itself here. */
window.addEventListener('trkvlt:audioplay', (e) => {
  const source = e.detail && e.detail.source;
  if (source !== 'cartReco' && cartRecoAudio && !cartRecoAudio.paused) {
    cartRecoAudio.pause();
    if (cartRecoActiveBody) cartRecoResetIcon(cartRecoActiveBody);
  }
  if (source !== 'upsell' && upsellAudio && !upsellAudio.paused) {
    upsellAudio.pause();
    const activeItem = document.querySelector('.pd-upsell-item');
    if (activeItem) {
      const b = activeItem.querySelector('.pd-upsell-play-btn');
      if (b) b.innerHTML = '<svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
      activeItem.querySelectorAll('.pd-upsell-bar').forEach(b => b.classList.remove('played'));
    }
  }
});

async function addRecommendedToCart(variantId, btn) {
  if (btn.disabled) return;
  btn.disabled = true;
  btn.textContent = '...';
  try {
    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    });
    btn.textContent = 'Added ✓';
    btn.classList.add('added');
    const cart = await fetchCart();
    renderCartDrawer(cart);
    updateCartBadge(cart.item_count);
  } catch (err) {
    console.error('Add recommended item failed:', err);
    btn.disabled = false;
    btn.textContent = 'Add';
  }
}

function renderCartDrawer(cart) {
  const body       = document.getElementById('cart-body');
  const footer     = document.getElementById('cart-drawer-footer');
  const emptyState = document.getElementById('cart-empty-state');
  const countLabel = document.getElementById('cart-count-label');
  const clearBtn   = document.getElementById('cart-clear-btn');

  refreshCartPaymentButton();
  renderCartRecommendations(cart);

  if (countLabel) countLabel.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
  if (clearBtn)   clearBtn.style.display  = cart.item_count > 0 ? 'block' : 'none';

  if (cart.item_count === 0) {
    if (body)       body.innerHTML = '';
    if (emptyState) emptyState.style.display = 'flex';
    if (footer)     footer.style.display = 'none';
    return;
  }

  if (emptyState) emptyState.style.display = 'none';
  if (footer)     footer.style.display = 'block';

  if (body) {
    body.innerHTML = cart.items.map((item, idx) => {
      const line = idx + 1;
      let propsHTML = '';
      if (item.properties && Object.keys(item.properties).length) {
        propsHTML = '<div style="margin-top:8px;font-size:12px;color:#999;">' +
          Object.entries(item.properties)
            .filter(([k]) => k !== 'null' && k !== '')
            .map(([k, v]) => `<div>${k}: ${v}</div>`).join('') +
          '</div>';
      }
      return `<div class="cart-item">
        <button class="cart-item-remove" onclick="removeCartItem(${line})" aria-label="Remove">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
        </button>
        <div class="cart-item-thumb">
          ${item.image ? `<img src="${item.image}" alt="" loading="lazy">` : '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M12 3v10.55A4 4 0 1 0 14 17V7h4V3h-6z"/></svg>'}
        </div>
        <div class="cart-item-info">
          <div class="cart-item-name">${item.title}</div>
          ${propsHTML}
          <div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;">
            <div class="cart-item-qty">
              <button class="cart-qty-btn" onclick="changeCartItemQty(${line}, ${item.quantity - 1})">-</button>
              <span class="cart-qty-num">${item.quantity}</span>
              <button class="cart-qty-btn" onclick="changeCartItemQty(${line}, ${item.quantity + 1})">+</button>
            </div>
            <div class="cart-item-price">${formatMoney(item.line_price)}</div>
          </div>
        </div>
      </div>`;
    }).join('');
  }

  const totalEl = document.getElementById('cart-total');
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function openCartDrawer() {
  document.getElementById('cart-overlay').classList.add('open');
  document.getElementById('cart-drawer').classList.add('open');
  document.body.style.overflow = 'hidden';
  cartDrawerOpen = true;
  fetchCart().then(renderCartDrawer);
}

function closeCartDrawer() {
  document.getElementById('cart-overlay').classList.remove('open');
  document.getElementById('cart-drawer').classList.remove('open');
  document.body.style.overflow = '';
  cartDrawerOpen = false;
}

/* ===== Search ===== */

function openSearch() {
  const overlay = document.getElementById('search-overlay');
  if (!overlay) return;
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  searchOpen = true;
  setTimeout(() => {
    const inp = document.getElementById('search-input');
    if (inp) inp.focus();
  }, 60);
}

function closeSearch() {
  const overlay = document.getElementById('search-overlay');
  if (!overlay) return;
  overlay.classList.remove('open');
  document.body.style.overflow = '';
  searchOpen = false;
  const inp = document.getElementById('search-input');
  if (inp) inp.value = '';
  const res = document.getElementById('search-results');
  if (res) res.innerHTML = '';
}

function handleSearchOverlayClick(e) {
  if (e.target === document.getElementById('search-overlay')) closeSearch();
}

function handleSearchInput(query) {
  clearTimeout(searchDebounce);
  if (!query.trim()) {
    const res = document.getElementById('search-results');
    if (res) res.innerHTML = '';
    return;
  }
  searchDebounce = setTimeout(() => runSearch(query), 280);
}

async function runSearch(query) {
  try {
    const url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[limit]=20' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    const r = await fetch(url);
    const data = await r.json();
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    // Filter out stems and unlimited rights add-on products
    products = products.filter(function(p) {
      var t = (p.title || '').toLowerCase();
      return !t.includes('stem') && !t.includes('unlimited');
    });
    renderSearchResults(products, query);
  } catch (err) {
    console.error('Search error:', err);
  }
}

function renderSearchResults(products, query) {
  const el = document.getElementById('search-results');
  if (!el) return;
  if (!products.length) {
    el.innerHTML = '<div class="search-no-results">No results for &ldquo;' + query + '&rdquo;</div>';
    return;
  }
  el.innerHTML = products.map(function(p) {
    var img = p.featured_image && p.featured_image.url
      ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">'
      : '<svg width="24" height="24" viewBox="0 0 24 24" fill="#333"><path d="M12 3v10.55A4 4 0 1 0 14 17V7h4V3h-6z"/></svg>';
    // Beat packs: product_type or URL contains 'pack'
    var isBeatPack = (p.product_type && p.product_type.toLowerCase().includes('pack'))
      || (p.url && p.url.toLowerCase().includes('pack'));
    var typeLabel = isBeatPack ? 'BEAT PACK' : 'BEAT';
    var typeBg = isBeatPack ? 'background:#1A1A1A;color:#9A9A9A;' : 'background:rgba(249,13,101,0.12);color:#F90D65;';
    // Beat packs go to their product page; individual beats go to the beat store
    var href = isBeatPack ? p.url : '/pages/beat-store';
    return '<a href="' + href + '" class="search-result-item">'
      + '<div class="search-result-img">' + img + '</div>'
      + '<div style="flex:1;min-width:0;">'
      + '<div class="search-result-title">' + p.title + '</div>'
      + '<div style="margin-top:4px;">'
      + '<span style="font-family:\"Plus Jakarta Sans\",system-ui,sans-serif;font-size:10px;font-weight:800;letter-spacing:0.8px;padding:2px 8px;border-radius:999px;' + typeBg + '">' + typeLabel + '</span>'
      + '</div>'
      + '</div></a>';
  }).join('');
}

/* ===== Product Page Social Proof ===== */

function trkvltScrollToReviews(el) {
  const target = document.getElementById('reviews');
  if (!target) return false;
  const headerOffset = 110;
  const rect = target.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const destY = rect.top + scrollTop - headerOffset;
  window.scrollTo({ top: destY, behavior: 'smooth' });
  if (typeof fbq === 'function') fbq('trackCustom', 'SocialProofReviewsOpened');
  if (typeof ttq !== 'undefined' && ttq.track) ttq.track('SocialProofReviewsOpened');
  return false;
}
window.trkvltScrollToReviews = trkvltScrollToReviews;

function trkvltInitSocialProofTracking() {
  const el = document.getElementById('pd-social-proof');
  if (!el || el.dataset.trkvltObserved) return;
  el.dataset.trkvltObserved = '1';
  if (typeof IntersectionObserver === 'undefined') { window.trkvltSocialProofViewed = true; return; }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !window.trkvltSocialProofViewed) {
        window.trkvltSocialProofViewed = true;
        if (typeof fbq === 'function') fbq('trackCustom', 'SocialProofViewed');
        if (typeof ttq !== 'undefined' && ttq.track) ttq.track('SocialProofViewed');
        observer.disconnect();
      }
    });
  }, { threshold: 0.5 });
  observer.observe(el);
}

function trkvltPageInit() {
  window.trkvltSocialProofViewed = false;
  trkvltInitSocialProofTracking();

  fetchCart().then(cart => {
    updateCartBadge(cart.item_count);

    const addonsEl = document.getElementById('pd-addons');
    if (addonsEl && cart.items) {
      const stemsId = Number(window.PRODUCT_STEMS_ID) || 0;
      const unlimId = Number(window.PRODUCT_UNLIMITED_ID) || 0;
      const stemsBox = document.querySelector('input[name="addon1"]');
      const unlimBox = document.querySelector('input[name="addon2"]');
      let changed = false;
      if (stemsBox && stemsId && cart.items.some(i => i.variant_id == stemsId)) {
        stemsBox.checked = true;
        stemsBox.closest('.pd-addon')?.classList.add('selected');
        changed = true;
      }
      if (unlimBox && unlimId && cart.items.some(i => i.variant_id == unlimId)) {
        unlimBox.checked = true;
        unlimBox.closest('.pd-addon')?.classList.add('selected');
        changed = true;
      }
      if (changed && typeof updatePrice === 'function') updatePrice();
    }
  });

  document.querySelectorAll('.optin-form').forEach(form => {
    if (form.dataset.trkvltBound) return;
    form.dataset.trkvltBound = '1';
    form.addEventListener('submit', e => {
      e.preventDefault();
      const btn = form.querySelector('.optin-btn');
      if (btn) { btn.textContent = "You're In!"; btn.style.background = '#0A0A0A'; }
      form.querySelectorAll('.optin-input').forEach(el => el.disabled = true);
    });
  });
}
window.trkvltPageInit = trkvltPageInit;

document.addEventListener('DOMContentLoaded', function () {
  trkvltPageInit();

  const cartBtn = document.getElementById('cart-nav-btn');
  if (cartBtn) cartBtn.addEventListener('click', e => { e.preventDefault(); openCartDrawer(); });

  const navToggle = document.getElementById('nav-toggle');
  const navLinksEl = document.querySelector('.nav-links');
  if (navToggle && navLinksEl) {
    navLinksEl.addEventListener('click', e => {
      if (e.target.closest('a, button')) navToggle.checked = false;
    });
  }

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      if (searchOpen) closeSearch();
      else if (cartDrawerOpen) closeCartDrawer();
    }
  });
});
